import { RP, PTO, SMARTPLEX } from 'utils/constants'
import strings from 'utils/strings'

/**
 * ROLES
 */
export const ADMIN = 'admin'
export const ENGINEER = 'engineer'
export const DEVELOPER = 'developer'
export const TECHNICIAN = 'technician'

export const PLUS_ADMIN = 'plusAdmin'
export const PLUS_ENGINEER = 'plusEngineer'
export const PLUS_DEVELOPER = 'plusDeveloper'
export const PLUS_TECHNICIAN = 'plusTechnician'

export const SUPER_ADMIN = 'superAdmin'

export const INTERNAL = 'internal'
export const PLUS = 'plus'
export const CHEC_DEV = 'checDev'
export const VIEWER = 'viewer'
export const PLUS_VIEWER = 'plusViewer'
// builder role depricated for viewer/viewerPlus
export const BUILDER = 'builder'
// This role allows a user to modify their own role within the application.
export const EDIT_OWN_ROLE = 'selfServiceRoles'

export const ALL_ROLES = [
  ADMIN,
  PLUS_ADMIN,
  ENGINEER,
  PLUS_ENGINEER,
  DEVELOPER,
  PLUS_DEVELOPER,
  TECHNICIAN,
  PLUS_TECHNICIAN,
  VIEWER,
  PLUS_VIEWER,
  INTERNAL,
  CHEC_DEV,
  EDIT_OWN_ROLE,
]

export const ALL_ROLES_WITH_LABEL = {
  [ADMIN]: strings.admin,
  [PLUS_ADMIN]: strings.plus_admin,
  [ENGINEER]: strings.engineer,
  [PLUS_ENGINEER]: strings.plus_engineer,
  [DEVELOPER]: strings.developer,
  [PLUS_DEVELOPER]: strings.plus_developer,
  [TECHNICIAN]: strings.technician,
  [PLUS_TECHNICIAN]: strings.plus_technician,
  [VIEWER]: strings.viewer,
  [PLUS_VIEWER]: strings.plus_viewer,
  [INTERNAL]: strings.internal_role_name,
  [CHEC_DEV]: strings.chec_dev,
  [EDIT_OWN_ROLE]: strings.edit_own_role_name,
}

/**
 * Common
 */
export const VIEW_S_AND_G_PART_SEARCH = 'view_s&g_part_search'
export const VIEW_CTP_MAPPING = 'view_ctp_mapping'
export const MOVE_CIRCUIT_AS_BUILT = 'move_circuit_as_built'
export const REMOVE_CIRCUIT_AS_BUILT = 'remove_circuit_as_built'
export const MOVE_CIRCUIT_AS_SERVICED = 'move_circuit_as_serviced'
export const REMOVE_CIRCUIT_AS_SERVICED = 'remove_circuit_as_serviced'
export const ADD_RELEASE_NOTES = 'add_release_notes'
export const REMOVE_42N_AS_BUILT_FEATURES = 'remove_42n_as_built_features'
export const VIEW_FEATURES = 'view_features'
export const SEARCH_FEATURES = 'search_features'

/**
 * CHEC+
 */
export const CREATE_PTO_TEMPLATE = 'create_pto_template'
export const EDIT_PTO_TEMPLATE = 'edit_pto_template'
export const CREATE_PLUS_PTO_TEMPLATE = 'create_plus_pto_template'
export const REMOVE_AS_BUILT_FEATURES = 'remove_as_built_features'
export const DOWNLOAD_PAR_FILES = 'download_par_files'
export const VIEW_PLUS_VEHICLES = 'view_plus_vehicles'
export const VIEW_PLUS_PRE_PROD_VEHICLES = 'view_plus_pre_prod_vehicles'
export const VIEW_PLUS_PRE_PROD_ECP = 'view_plus_pre_prod_ecp'
export const CREATE_AFTER_MARKET_XMC = 'create_aftermarket_xmc'
export const VIEW_PLUS_VEHICLE_ECP = 'view_plus_vehicle_ecp'
export const EDIT_PLUS_VEHICLE_ECP = 'edit_plus_vehicle_ecp'
export const ADD_PLUS_VEHICLE_FAVORITES = 'add_plus_vehicle_favorites'
export const UPDATE_PLUS_VEHICLE_FEATURE = {
  ASAM: 'update_plus_vehicle_feature_asam',
  XMC1: 'update_plus_vehicle_feature_xmc1',
  XMC2: 'update_plus_vehicle_feature_xmc2',
  XMC3: 'update_plus_vehicle_feature_xmc3',
  XMC4: 'update_plus_vehicle_feature_xmc4',
  XMC5: 'update_plus_vehicle_feature_xmc5',
  XMC6: 'update_plus_vehicle_feature_xmc6',
  XMC7: 'update_plus_vehicle_feature_xmc7',
  XMC8: 'update_plus_vehicle_feature_xmc8',
}
export const VIEW_PLUS_PTO_PENDING = 'view_plus_pto_pending'
export const UPDATE_PLUS_PTO = 'update_plus_pto'
export const CREATE_FEATURE_COLLECTION = 'create_feature_collection'
export const EDIT_FEATURE_COLLECTION = 'edit_feature_collection'
export const ACTIVATE_FEATURE_COLLECTION = 'activate_feature_collection'
export const OBSOLETE_FEATURE_COLLECTION = 'obsolete_feature_collection'
export const DUPLICATE_FEATURE_COLLECTION = 'duplicate_feature_collection'
export const VIEW_FEATURE_COLLECTION_REVISION =
  'view_feature_collection_revision'
export const EDIT_PLUS_S_AND_G = 'edit_plus_s&g'
export const EDIT_PLUS_PRE_PROD_S_AND_G = 'edit_plus_pre_prod_s&g'
export const VIEW_PLUS_S_AND_G_ON_PRE_PROD_VEHICLE =
  'view_plus_s&g_on_pre_prod_vehicle'
export const VIEW_PLUS_S_AND_G_ON_POST_PROD_VEHICLE =
  'view_plus_s&g_on_post_prod_vehicle'
export const VIEW_PLUS_MANAGE_FLEET = 'view_plus_manage_fleet'
export const UPDATE_PLUS_MANAGE_FLEET = 'update_plus_manage_fleet'

export const CREATE_FEATURE = {
  ASAM: 'create_feature_asam',
  XMC1: 'create_feature_xmc1',
  XMC2: 'create_feature_xmc2',
  XMC3: 'create_feature_xmc3',
  XMC4: 'create_feature_xmc4',
  XMC5: 'create_feature_xmc5',
  XMC6: 'create_feature_xmc6',
  XMC7: 'create_feature_xmc7',
  XMC8: 'create_feature_xmc8',
  INTERNAL: 'create_internal_feature',
  SERVICE: 'create_service_feature',
}

export const UPDATE_SERVICE_FEATURE_SAME_ORG = {
  XMC3: 'update_service_feature_xmc3_same_org',
  XMC4: 'update_service_feature_xmc4_same_org',
  XMC5: 'update_service_feature_xmc5_same_org',
  XMC6: 'update_service_feature_xmc6_same_org',
  XMC7: 'update_service_feature_xmc7_same_org',
  XMC8: 'update_service_feature_xmc8_same_org',
}

export const UPDATE_FEATURE_ANY_ORG = {
  ASAM: 'update_feature_asam_any_org',
  XMC1: 'update_feature_xmc1_any_org',
  XMC2: 'update_feature_xmc2_any_org',
  XMC3: 'update_feature_xmc3_any_org',
  XMC4: 'update_feature_xmc4_any_org',
  XMC5: 'update_feature_xmc5_any_org',
  XMC6: 'update_feature_xmc6_any_org',
  XMC7: 'update_feature_xmc7_any_org',
  XMC8: 'update_feature_xmc8_any_org',
}

export const UPDATE_SERVICE_FEATURE_ANY_ORG = {
  ASAM: 'update_service_feature_asam_any_org',
  XMC1: 'update_service_feature_xmc1_any_org',
  XMC2: 'update_service_feature_xmc2_any_org',
}

export const EDIT_INTERNAL_FEATURES = 'edit_internal_features'

export const DUPLICATE_FEATURE = {
  ASAM: 'duplicate_feature_asam',
  XMC1: 'duplicate_feature_xmc1',
  XMC2: 'duplicate_feature_xmc2',
  XMC3: 'duplicate_feature_xmc3',
  XMC4: 'duplicate_feature_xmc4',
  XMC5: 'duplicate_feature_xmc5',
  XMC6: 'duplicate_feature_xmc6',
  XMC7: 'duplicate_feature_xmc7',
  XMC8: 'duplicate_feature_xmc8',
}

export const DUPLICATE_FEATURE_OTHER_ORG = {
  ASAM: 'duplicate_feature_asam_other_org',
  XMC1: 'duplicate_feature_xmc1_other_org',
  XMC2: 'duplicate_feature_xmc2_other_org',
  XMC3: 'duplicate_feature_xmc3_other_org',
  XMC4: 'duplicate_feature_xmc4_other_org',
  XMC5: 'duplicate_feature_xmc5_other_org',
  XMC6: 'duplicate_feature_xmc6_other_org',
  XMC7: 'duplicate_feature_xmc7_other_org',
  XMC8: 'duplicate_feature_xmc8_other_org',
}

export const ACTIVATE_SERVICE_FEATURE_SAME_ORG = {
  XMC3: 'activate_service_feature_xmc3_same_org',
  XMC4: 'activate_service_feature_xmc4_same_org',
}

export const ACTIVATE_FEATURE_ANY_ORG = {
  ASAM: 'activate_feature_asam_any_org',
  XMC1: 'activate_feature_xmc1_any_org',
  XMC2: 'activate_feature_xmc2_any_org',
  XMC3: 'activate_feature_xmc3_any_org',
  XMC4: 'activate_feature_xmc4_any_org',
}

export const ACTIVATE_SERVICE_FEATURE_ANY_ORG = {
  ASAM: 'activate_service_feature_asam_any_org',
  XMC1: 'activate_service_feature_xmc1_any_org',
  XMC2: 'activate_service_feature_xmc2_any_org',
}

export const UPDATE_PLUS_SWITCH_LOCATION_DETAIL =
  'update_plus_switch_location_detail'
export const UPDATE_PLUS_SWITCH_CUSTOM_GRAPHIC =
  'update_plus_switch_custom_graphic'
export const EDIT_PLUS_DASHBOARD_LAYOUT = 'edit_plus_dashboard_layout'
export const PLUS_CREATE_APPROVED_DASH_LAYOUT =
  'plus_create_approved_dash_layout'

/**
 * CHEC2
 */
export const VIEW_M2_S_AND_G_ON_POST_PROD_VEHICLE =
  'view_m2_s&g_on_post_prod_vehicle'
export const VIEW_M2_S_AND_G_ON_PRE_PROD_VEHICLE =
  'view_m2_s&g_on_pre_prod_vehicle'
export const EDIT_PRE_PROD_S_AND_G = 'edit_pre_prod_s&g'
export const EDIT_M2_S_AND_G = 'edit_m2_s&g'
export const ADD_M2_VEHICLE_FAVORITES = 'add_m2_vehicle_favorites'
export const ADD_RP_TO_VEHICLE = 'add_rp_to_vehicle'
export const REFRESH_ALL_RPS = 'refresh_all_rps'
export const VIEW_REFERENCE_PARAMETERS = 'view_reference_parameters'
export const VIEW_DATA_TRANSLATOR = 'view_data_translator_plus'
export const VIEW_REFERENCE_PARAMETERS_CONTROLS =
  'view_reference_parameters_controls'
export const VIEW_SUPPORT_PARAMETERS = 'view_support_parameters'
export const UPDATE_M2_NOTES = 'update_m2_notes'
export const ADD_SWITCH = 'add_switch_plus_s&g'

export const EDIT_EXTERNAL_REFERENCE_PARAMETERS = {
  [SMARTPLEX]: 'edit_rp_smartplex',
  [PTO]: 'edit_rp_pto',
  [RP]: 'edit_rp',
}

export const EDIT_INTERNAL_REFERENCE_PARAMETERS = {
  [SMARTPLEX]: 'edit_internal_rp_smartplex',
  [PTO]: 'edit_internal_rp_pto',
  [RP]: 'edit_internal_rp',
}

export const ACTIVATE_EXTERNAL_REFERENCE_PARAMETERS = {
  [SMARTPLEX]: 'activate_rp_smartplex',
  [PTO]: 'activate_rp_pto',
  [RP]: 'activate_rp',
}

export const ACTIVATE_INTERNAL_REFERENCE_PARAMETERS = {
  [SMARTPLEX]: 'activate_internal_rp_smartplex',
  [PTO]: 'activate_internal_rp_pto',
  [RP]: 'activate_internal_rp',
}

export const DUPLICATE_RP_SMARTPLEX = 'duplicate_rp_smartplex'
export const DUPLICATE_RP_PTO = 'duplicate_rp_pto'
export const DUPLICATE_RP = 'duplicate_rp'

export const DUPLICATE_REFERENCE_PARAMETERS = {
  [SMARTPLEX]: DUPLICATE_RP_SMARTPLEX,
  [PTO]: DUPLICATE_RP_PTO,
  [RP]: DUPLICATE_RP,
}

export const CREATE_RP_COLLECTIONS = 'create_rp_collections'
export const EDIT_RP_COLLECTIONS = 'edit_rp_collections'
export const OBSOLETE_FEATURE = 'obsolete_feature'

export const VIEW_FEATURE_REVISION = 'view_feature_revision'

export const CREATE_FEATURE_REVISION = {
  INTERNAL_MODULES: 'create_feature_revision_internal_modules',
  CUSTOM_MODULES: 'create_feature_revision_custom_modules',
}

export const EDIT_INTERNAL_SUPPORT_PARAMETERS = {
  INTERNAL_NATIVE_SP: 'edit_internal_native_sp',
  INTERNAL_O_CAN: 'edit_internal_o_can',
  INTERNAL_O_MAP: 'edit_internal_o_map',
  INTERNAL_O_MLOGIC: 'edit_internal_o_mlogic',
  INTERNAL_O_MLOGIC_PTO: 'edit_internal_o_mlogic_pto',
  INTERNAL_O_MLOGIC_SMARTPLEX: 'edit_internal_o_mlogic_smartplex',
  INTERNAL_O_PLC: 'edit_internal_o_plc',
  INTERNAL_O_SLOTCOPY: 'edit_internal_o_slotcopy',
  INTERNAL_O_SLOTCOPY_PTO: 'edit_internal_o_slotcopy_pto',
  INTERNAL_O_SLOTCOPY_SMARTPLEX: 'edit_internal_o_slotcopy_smartplex',
  INTERNAL_O_TIMER: 'edit_internal_o_timer',
  INTERNAL_O_TIMER_PTO: 'edit_internal_o_timer_pto',
  INTERNAL_O_TIMER_SMARTPLEX: 'edit_internal_o_timer_smartplex',
}

export const EDIT_OPEN_SUPPORT_PARAMETERS = {
  OPEN_NATIVE_SP: 'edit_open_native_sp',
  OPEN_O_CAN: 'edit_open_o_can',
  OPEN_O_MAP: 'edit_open_o_map',
  OPEN_O_MLOGIC: 'edit_open_o_mlogic',
  OPEN_O_MLOGIC_PTO: 'edit_open_o_mlogic_pto',
  OPEN_O_MLOGIC_SMARTPLEX: 'edit_open_o_mlogic_smartplex',
  OPEN_O_PLC: 'edit_open_o_plc',
  OPEN_O_SLOTCOPY: 'edit_open_o_slotcopy',
  OPEN_O_SLOTCOPY_PTO: 'edit_open_o_slotcopy_pto',
  OPEN_O_SLOTCOPY_SMARTPLEX: 'edit_open_o_slotcopy_smartplex',
  OPEN_O_TIMER: 'edit_open_o_timer',
  OPEN_O_TIMER_PTO: 'edit_open_o_timer_pto',
  OPEN_O_TIMER_SMARTPLEX: 'edit_open_o_timer_smartplex',
}

export const DUPLICATE_INTERNAL_SP = {
  DUPLICATE_INTERNAL_NATIVE_SP: 'duplicate_internal_native_sp',
  DUPLICATE_INTERNAL_O_CAN: 'duplicate_internal_o_can',
  DUPLICATE_INTERNAL_O_MAP: 'duplicate_internal_o_map',
  DUPLICATE_INTERNAL_O_MLOGIC: 'duplicate_internal_o_mlogic',
  DUPLICATE_INTERNAL_O_MLOGIC_PTO: 'duplicate_internal_o_mlogic_pto',
  DUPLICATE_INTERNAL_O_MLOGIC_SMARTPLEX:
    'duplicate_internal_o_mlogic_smartplex',
  DUPLICATE_INTERNAL_O_PLC: 'duplicate_internal_o_plc',
  DUPLICATE_INTERNAL_O_SLOTCOPY: 'duplicate_internal_o_slotcopy',
  DUPLICATE_INTERNAL_O_SLOTCOPY_PTO: 'duplicate_internal_o_slotcopy_pto',
  DUPLICATE_INTERNAL_O_SLOTCOPY_SMARTPLEX:
    'duplicate_internal_o_slotcopy_smartplex',
  DUPLICATE_INTERNAL_O_TIMER: 'duplicate_internal_o_timer',
  DUPLICATE_INTERNAL_O_TIMER_PTO: 'duplicate_internal_o_timer_pto',
  DUPLICATE_INTERNAL_O_TIMER_SMARTPLEX: 'duplicate_internal_o_timer_smartplex',
}

export const DUPLICATE_OPEN_SP = {
  DUPLICATE_OPEN_NATIVE_SP: 'duplicate_open_native_sp',
  DUPLICATE_OPEN_O_CAN: 'duplicate_open_o_can',
  DUPLICATE_OPEN_O_MAP: 'duplicate_open_o_map',
  DUPLICATE_OPEN_O_MLOGIC: 'duplicate_open_o_mlogic',
  DUPLICATE_OPEN_O_MLOGIC_PTO: 'duplicate_open_o_mlogic_pto',
  DUPLICATE_OPEN_O_MLOGIC_SMARTPLEX: 'duplicate_open_o_mlogic_smartplex',
  DUPLICATE_OPEN_O_PLC: 'duplicate_open_o_plc',
  DUPLICATE_OPEN_O_SLOTCOPY: 'duplicate_open_o_slotcopy',
  DUPLICATE_OPEN_O_SLOTCOPY_PTO: 'duplicate_open_o_slotcopy_pto',
  DUPLICATE_OPEN_O_SLOTCOPY_SMARTPLEX: 'duplicate_open_o_slotcopy_smartplex',
  DUPLICATE_OPEN_O_TIMER: 'duplicate_open_o_timer',
  DUPLICATE_OPEN_O_TIMER_PTO: 'duplicate_open_o_timer_pto',
  DUPLICATE_OPEN_O_TIMER_SMARTPLEX: 'duplicate_open_o_timer_smartplex',
}

export const DUPLICATE_SP = {
  ...DUPLICATE_INTERNAL_SP,
  ...DUPLICATE_OPEN_SP,
}

export const DUPLICATE_SP_RIGHTS = Object.values(DUPLICATE_SP)

export const VIEW_DASH_BUILDER_M2 = 'view_dash_builder_m2'
export const VIEW_DASH_BUILDER_PLUS = 'view_dash_builder_plus'
export const VIEW_DASH_ENGINEER_M2 = 'view_dash_engineer_m2'
export const VIEW_DASH_ENGINEER_PLUS = 'view_dash_engineer_plus'

export const M2_ROLES = [ADMIN, ENGINEER, DEVELOPER, TECHNICIAN]

export const UPDATE_PLUS_NOTES = 'update_plus_notes'

export const ADD_NEW_VEHICLE_COMMENT = [
  'plus_create_vehicle_comment',
  'create_vehicle_comment',
]

export const CHEC2_ROLES = [
  PLUS_ADMIN,
  PLUS_ENGINEER,
  PLUS_DEVELOPER,
  PLUS_TECHNICIAN,
]

export const VIEW_M2_MANAGE_FLEET = 'view_m2_manage_fleet'
export const UPDATE_M2_MANAGE_FLEET = 'update_m2_manage_fleet'

export const CREATE_M2_EXM = 'create_m2_exm'
export const UPDATE_M2_EXM = 'update_m2_exm'
export const UPDATE_M2_SWITCH_LOCATION_DETAIL =
  'update_m2_switch_location_detail'
export const UPDATE_M2_SWITCH_CUSTOM_GRAPHIC = 'update_m2_switch_custom_graphic'

export const EDIT_INTERNAL_RP = 'edit_internal_rp'

export const VIEW_MANAGE_FLEET = 'view_manage_fleet'
export const UPDATE_MANAGE_FLEET = 'update_m2_manage_fleet'
export const EDIT_DASHBOARD_LAYOUT = 'edit_dashboard_layout'
export const CREATE_APPROVED_DASH_LAYOUT = 'create_approved_dash_layout'

// This permission allows a user to modify their own role within the application.
export const EDIT_OWN_USER_ROLES = 'edit_own_user_roles'

export const VIEW_VEHICLE_SNAPSHOTS = 'view_vehicle_snapshots'

/**
 * Rights replacing legacy role checks (WI #502155)
 */
// Configure and activate system alerts (Wiki #25, Ai)
export const CONFIGURE_SYSTEM_ALERT = 'configure_system_alert'
// Add/remove/edit solenoids on CHEC+ service vehicles (Wiki #34, +TDEA)
export const EDIT_PLUS_VEHICLE_SOLENOIDS = 'edit_plus_vehicle_solenoids'
// View developer-tier documentation sections (DEA / +DEA)
export const VIEW_DEVELOPER_DOCUMENTATION = 'view_developer_documentation'
// View admin-tier documentation sections (A / +A)
export const VIEW_ADMIN_DOCUMENTATION = 'view_admin_documentation'
// View engineer-tier documentation sections (EA / +EA)
export const VIEW_ENGINEER_DOCUMENTATION = 'view_engineer_documentation'
// View technician-tier documentation sections (TDEA / +TDEA)
export const VIEW_TECHNICIAN_DOCUMENTATION = 'view_technician_documentation'
// Manage "fast features" in CHEC+ (internal Admin/PlusAdmin only)
export const MANAGE_FAST_FEATURES = 'manage_fast_features'
// View fast feature errors nav item (internal Admin/PlusAdmin only)
export const VIEW_FAST_FEATURE_ERRORS = 'view_fast_feature_errors'
// View M2 vehicles (Technician+, not Viewer)
export const VIEW_M2_VEHICLES = 'view_m2_vehicles'
